// @ts-strict-ignore
import { LMFormatterService } from './lm-formatter.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

export const lmFieldFormatter  = (
  lmFormatterService: LMFormatterService,
  lmFormatUtilService: LMFormatUtilService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): string  => {

  if (dataView.isTreeMoreLink) {
    const moreColumnIndex = dataGrid?.settings.selectable === 'single' ? 0 : 1;
    return lmFormatterService.getMoreLink(cell, dataView, moreColumnIndex);
  }

  const displayField = columnDef.displayField;

  if (displayField.visibility) {
    if (!lmFormatterService.isConditionValid(displayField.visibility, dataView)) {
      return '';
    }
  }

  if (displayField.inlineCreateFieldId) {
    if (dataView.fields && dataView.fields[ displayField.inlineCreateFieldId ]) {
      // LMCLIENT-34312: Value is escaped and the formatted value will be HTML encoded to be displayed in cell node HTML.
      // dataView.fields(displayField.fieldId) is already set using the unescaped coerced value in sohoxi.
      // (See SOHO Datagrid's commitCellEdit that calls updateCellNode routine)
      if (dataView.fields[ displayField.fieldId ]) {
        dataView.fields[ displayField.inlineCreateFieldId ].value = dataView.fields[ displayField.fieldId ].value;
      } else {
        dataView.fields[ displayField.inlineCreateFieldId ].value = value;
      }
    }
  }

  if (columnDef.isAggField && displayField.displayMsgRule && displayField.displayWhen) {
    if (lmFormatterService.isConditionValid([ displayField.displayWhen ], dataView)) {
      return lmFormatUtilService.formatMessageRule(displayField.displayMsgRule, dataView);
    }
  }

  const listGridComponent = dataGrid.settings.userObject();
  const displayValue = lmFormatterService.getDisplayText(displayField, value, dataView, listGridComponent.dataViewSet, row);
  const displayText =  lmFormatterService.formatDisplayText(row, cell, displayValue, columnDef, dataView, dataGrid);

  if (lmFormatterService.expandableRowCardView() && columnDef.columnNumber === 0) {
    return Soho.Formatters.Expander(row, cell, displayText, columnDef, dataView, dataGrid);
  }

  return displayText;
};
